// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"231":"0806e034","370":"0e3c501d","399":"2fff0f80","619":"f190bd02","727":"77307890","732":"89c03943","803":"5c526bb5","877":"685bf6df"}[chunkId] + ".chunk.css";
};